import apiClient from "./apiClient";

const withoutEmpty = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value != null),
  );

// The employee is taken from the access token, so "my" endpoints don't
// take an employeeId.
export const leaveService = {
  // LeaveBalance[] with numeric allocated/used/pending/booked/available.
  // `year` defaults to the current year on the server.
  getMyBalances: ({ year, leaveTypeId } = {}) =>
    apiClient.get("/leave/my/balances", {
      params: withoutEmpty({ year, leaveTypeId }),
    }),

  // LeaveRequest[] newest first. Filters: status (lowercase), year, leaveTypeId.
  getMyRequests: (filters = {}) =>
    apiClient.get("/leave/my/requests", { params: withoutEmpty(filters) }),

  // { leaveTypeId, startDate, endDate, totalDays (0.5 steps), reason }
  fileLeave: (data) => apiClient.post("/leave/my/request", data),

  // Same body as filing. Pending: changed now, approval restarts.
  // Approved: the new details wait for approval (pendingChange EDIT).
  editMyLeave: (id, data) => apiClient.patch(`/leave/my/${id}`, data),

  // Pending or approved: waits for approval (pendingChange CANCEL); the days
  // return only when an approver accepts.
  cancelMyLeave: (id, reason) =>
    apiClient.patch(`/leave/my/${id}/cancel`, withoutEmpty({ reason })),

  // Takes back a cancellation or edit waiting for approval.
  withdrawLeaveChange: (id) =>
    apiClient.patch(`/leave/my/${id}/withdraw-change`, {}),
};
